import { waitForAngular } from 'App/AngularApp';
import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';
import AppService from 'App/legacy/AppService';
import StateRouter from 'App/services/StateRouter';

type PortedRouteConfig = {
	angularState: string;
	featureFlag: string;
};

const portedRoutes = [
	{
		angularState: 'appointments',
		featureFlag: 'REACT_APPOINTMENTS_LIST'
	} as const,
	{
		angularState: 'periodizations',
		featureFlag: 'REACT_PERIODIZATIONS_PAGE'
	} as const
] satisfies PortedRouteConfig[];

const getFeatureFlag = (angularState: string) => {
	const portedRoute = portedRoutes.find(route => route.angularState === angularState);
	return portedRoute?.featureFlag || '';
};

export const setupPortedAngularStates = () => {
	for (const route of portedRoutes) {
		if (hasSoftDeployAccess(route.featureFlag)) {
			// Haxxing to make angular state not do anything
			// Resolves cannot be disabled like this - need to be handled separately
			const oldState = StateRouter.get(route.angularState) as any;

			delete oldState.controller;
			delete oldState.controllerProvider;
			delete oldState.templateProvider;
			delete oldState.templateUrl;

			oldState.template = '<div></div>';
		}
	}
};

export const checkPortedResolve = async <TReturn extends any>(angularState: string, resolveFn: () => TReturn) => {
	const flag = getFeatureFlag(angularState);
	const hasFlag = hasSoftDeployAccess(flag);
	await waitForAngular();
	return AppService.loadedPromise.then(() => {
		if (hasFlag) {
			return;
		}
		return resolveFn();
	});
};
